import { setAlertModal, setLoading } from "./app";
import { resetInitialHomeState } from "./anonHomeForm";
import { resetInitialAutoState } from "./anonAutoForm";
import axiosInstance from "../../utilities/interceptorUtilities";
import { formSubmissionError } from "../../constants/messages";
import { renameFile } from "../../utilities/appUtilities";
import { formatDate, formatTime } from "../../utilities/formatUtilities";
import { concatenateName } from "../../utilities/dataUtilities";
import { replaceTriggers } from "../../utilities/firewallUtilities";
import { COMMERCIAL, PERSONAL } from "../../constants/keys";

export const SET_CAN_ADVANCE = "SET_CAN_ADVANCE";
export const SET_POLICY_NUMBER = "SET_POLICY_NUMBER";
export const SET_TYPE_OF_CLAIM = "SET_TYPE_OF_CLAIM";
export const SET_POLICY_TYPE_TOGGLE = "SET_POLICY_TYPE_TOGGLE";
export const SEND_AUTO_FORM = "SEND_AUTO_FORM";
export const SEND_PROPERTY_FORM = "SEND_PROPERTY_FORM";
export const SEND_AUTO_GLASS_FORM = "SEND_AUTO_GLASS_FORM";
export const CLEAR_FORM = "CLEAR_FORM";
export const RESET_INITIAL_STATE = "RESET_INITIAL_STATE";
export const SET_URL_PARAMS_TO_REGISTER = "SET_URL_PARAMS_TO_REGISTER";
export const SET_ATTACHMENT_FAILURES = "SET_ATTACHMENT_FAILURES";

export const setCanAdvance = (canAdvance) => {
  return (dispatch) => {
    dispatch({ type: SET_CAN_ADVANCE, canAdvance });
  };
};

export const setPolicyNumber = (policyNumber) => {
  return (dispatch) => {
    dispatch({ type: SET_POLICY_NUMBER, policyNumber });
  };
};

export const setTypeOfClaim = (claimType) => {
  return (dispatch) => {
    dispatch({ type: SET_TYPE_OF_CLAIM, claimType });
  };
};

export const setPolicyTypeToggle = (toggle) => {
  return (dispatch) => {
    dispatch({ type: SET_POLICY_TYPE_TOGGLE, toggle });
  };
};

export const resetClearForm = () => {
  return async (dispatch) => {
    dispatch({ type: CLEAR_FORM, clear: { auto: false, property: false } });
  };
};

export const setUrlParamsToRegister = (urlParamsToRegister) => {
  return (dispatch) => {
    dispatch({ type: SET_URL_PARAMS_TO_REGISTER, urlParamsToRegister });
  };
};

export const sendAutoForm = (
  formData,
  documents,
  claimType,
  formType,
  history
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const form = new FormData();

      const url =
        process.env.REACT_APP_API_URL +
        "/api/ReportClaim/GenerateAnonymousPdfSendEmail";
      formData.claimId = 0;
      formData.emailId = formData.contactEmail;
      formData.claimType = claimType;
      formData.policyType = getState().anonymousForms.policyTypeToggle[0].selected === true
      ? PERSONAL
      : COMMERCIAL;
      formData.formType = formType;
      formData.propertyParty = 0;
      formData.userBeingImpersonated = "";
      formData.homeOrAuto = "AUTO";
      formData.whereDate = `${formatDate(formData.whereDate)} ${formatTime(`${formData.whereDate} ${formData.whereTime}`)}`;
      delete formData.whereTime;
      formData.driverId = null;
      formData.vehicleId = null;
      formData.otherVehicleOwnerInsuranceName = "";
      formData.agentCode = "";
      formData.isFromAgent = false;

      let formString = JSON.stringify(formData);
      formString = replaceTriggers(formString);
      form.append("form", formString);

      documents.forEach((file) => {
        let fileName = file.name;
        const newFile = renameFile(file, fileName.replace("'", ""));
        form.append(newFile.name, newFile);
      });

      const response = await axiosInstance.post(url, form, {
        withCredentials: true,
      });
      if (response.status !== 200) {
        throw new Error(`${response.status} ${response.statusText}`);
      }
      const data = await response.data;
      const referenceNumber = data?.ClaimRefNumber;
      const attachmentFailures = data?.AttachmentFailures;
      console.log(`Reference # : ${referenceNumber}`);
      dispatch({
        type: SET_URL_PARAMS_TO_REGISTER,
        urlParamsToRegister: {
          policyNumber: formData.policyNumber.trim(),
          name: `${
            concatenateName({
              firstName: { value: formData.contactFirstName },
              lastName: { value: formData.contactLastName }}
            )}`,
          phone: formData.contactPhone.trim(),
          email: formData.contactEmail.trim(),
        },
      });
      dispatch({ type: CLEAR_FORM, clear: { auto: true, property: false } });
      dispatch({ type: SEND_AUTO_FORM, referenceNumber });
      dispatch(resetInitialAutoState());//DEAL HERE
      dispatch(setLoading(false));
      dispatch(setAttachmentFailures(attachmentFailures));
      history.push("/fileaclaim/thankyou");
    } catch (err) {
      console.log(`Error: ${err.message}`);
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", formSubmissionError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const sendPropertyForm = (
  formData,
  documents,
  history
) => {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
    
      const form = new FormData();

      const url =
        process.env.REACT_APP_API_URL +
        "/api/ReportClaim/GenerateAnonymousPdfSendEmail";

      formData.claimId = 0;
      formData.emailId = formData.contactEmail;
      formData.policyType =  getState().anonymousForms.policyTypeToggle[0].selected === true
        ? PERSONAL
        : COMMERCIAL;
      formData.propertyPart = 0;
      formData.homeOrAuto = "HOME";
      formData.userBeingImpersonated = "";
      formData.whereDate = `${formatDate(formData.whereDate)} ${formatTime(`${formData.whereDate} ${formData.whereTime}`)}`
      delete formData.whereTime;

      let formString = JSON.stringify(formData);

      formString = replaceTriggers(formString);
      form.append("form", formString);

      documents.forEach((file) => {
        form.append(file.name, file);
      });

      const response = await axiosInstance.post(url, form, {
        withCredentials: true,
      });

      if (response.status !== 200) {
        throw new Error(`${response.status} ${response.statusText}`);
      }

      const data = await response.data;
      const referenceNumber = data?.ClaimRefNumber;
      const attachmentFailures = data?.AttachmentFailures;
      // store the information that can be used to register user in customer care
      dispatch({
        type: SET_URL_PARAMS_TO_REGISTER,
        urlParamsToRegister: {
          policyNumber: formData.policyNumber.trim(),
          name: `${
            concatenateName({
              firstName: { value: formData.contactFirstName },
              lastName: { value: formData.contactLastName }}
            )}`,
          phone: formData.contactPhone.trim(),
          email: formData.contactEmail.trim(),
        },
      });
      dispatch({ type: CLEAR_FORM, clear: { auto: false, property: true } });
      dispatch({ type: SEND_PROPERTY_FORM, referenceNumber });
      dispatch(setLoading(false));
      dispatch(resetInitialHomeState());
      dispatch(setAttachmentFailures(attachmentFailures));

      history.push("/fileaclaim/thankyou");
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", formSubmissionError));
      console.log(`Home Claim Submission Error: ${err.message}`);
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
      console.log(err.message);
    }
  };
};

export const sendAutoGlassForm = (policyNumber) => {
  return async (dispatch, getState) => {
    try {
      const url =
        process.env.REACT_APP_API_URL +
        "/api/Claims/GetAnonymousAutoGlassPolicySignature";
      let body = { PolicyNumber: policyNumber.split("/")[0] };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      const autoGlassPolicySignature = await response.data;

      let form = window.document.createElement("form");
      form.setAttribute("id", "safeliteForm");
      form.setAttribute("method", "post");
      form.setAttribute("action", process.env.REACT_APP_SAFELITE_URL);
      form.setAttribute("target", "_blank");
      window.document.body.appendChild(form);

      var sPolicyNumber = window.document.createElement("input");
      sPolicyNumber.setAttribute("type", "hidden");
      sPolicyNumber.setAttribute("name", "PolicyNumber");
      sPolicyNumber.setAttribute(
        "value",
        autoGlassPolicySignature.PolicyNumber
      );
      window.document.getElementById("safeliteForm").appendChild(sPolicyNumber);

      var sToken = window.document.createElement("input");
      sToken.setAttribute("type", "hidden");
      sToken.setAttribute("name", "Token");
      sToken.setAttribute("value", autoGlassPolicySignature.Token);
      window.document.getElementById("safeliteForm").appendChild(sToken);

      var sSignature = window.document.createElement("input");
      sSignature.setAttribute("type", "hidden");
      sSignature.setAttribute("name", "Signature");
      sSignature.setAttribute("value", autoGlassPolicySignature.Signature);
      window.document.getElementById("safeliteForm").appendChild(sSignature);

      form.submit();
      window.document.body.removeChild(form);
    } catch (err) {
      dispatch(setAlertModal(true, "error", formSubmissionError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

const setAttachmentFailures = (attachmentFailures) => {
  return (dispatch) => {
    dispatch({ type: SET_ATTACHMENT_FAILURES, attachmentFailures });
  };
};

export const clearAnonAttachmentFailures = () => {
  return (dispatch) => {
    dispatch({ type: SET_ATTACHMENT_FAILURES, attachmentFailures: [] });
  };
};

export const resetInitialState = () => {
  return (dispatch) => {
    dispatch({ type: RESET_INITIAL_STATE });
  };
};

export const neutralizeInput = (input) => {
  let neutralizedInput = input;
  neutralizedInput = neutralizedInput.replaceAll(">", "");
  neutralizedInput = neutralizedInput.replaceAll("<", "");
  neutralizedInput = neutralizedInput.replaceAll("&", "");
  neutralizedInput = neutralizedInput.replaceAll("{", "");
  neutralizedInput = neutralizedInput.replaceAll("}", "");
  neutralizedInput = neutralizedInput.replaceAll("$", "");
  neutralizedInput = neutralizedInput.replaceAll("#", "");
  return neutralizedInput;
};

export const containsSpecials = (input) => {
  let outlawed = /[\[\]#$%^\&<>\*\`\\]/;
  return input.match(outlawed) !== null;
};
